module.exports = __webpack_public_path__ + "img/rocket-icon.3f2b1e60.svg";